import { POST } from "../../APiHelper/API";
let source
export const searchTeams = (name, season_id, onSuccess, onError) => {
    const data = {
        name: name,
        season_id: season_id
    }

    source = POST(`/api/v1/leagues/team/`, data, onSuccess, onError, true, source)
}